import { createReducer } from "redux-act";
import { Record } from "immutable";

import * as actions from "./actions";

const State = Record({
  sidebarOpen: false,
  isAppLoading: 0
});

const reducer = createReducer(
  {
    [actions.sidebarToggle]: state =>
      state.set("sidebarOpen", !state.get("sidebarOpen")),
    [actions.sidebarClose]: state => state.set("sidebarOpen", false),
    [actions.increaseLoading]: state =>
      state.set("isAppLoading", state.get("isAppLoading") + 1),
    [actions.decreaseLoading]: state =>
      state.set("isAppLoading", state.get("isAppLoading") - 1)
  },
  new State()
);

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducer.js